import { render, staticRenderFns } from "./TabbedList.vue?vue&type=template&id=562c49ba"
import script from "./TabbedList.vue?vue&type=script&lang=js"
export * from "./TabbedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports